
import { Vue, prop } from "vue-class-component";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { FeedbackController } from "../../controllers/FeedbackController";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";

class Props {
  collapse = prop<boolean>({
    default: false,
    type: Boolean
  });
}

export default class CardReview extends Vue.with(Props) {
  // refs

  // flags
  flagAutoShowPopupFeedback = FlagsMedusa.flag_auto_show_popup_feedback.isEnabled();

  // computed
  get eligibleShowPopupFeedback() {
    return (
      !IS_SENDER_ACCOUNT && FlagsMedusa.flag_sidebar_menu_feedback.isEnabled()
    );
  }

  // methods
  openTooltip(event: any) {
    (this.$refs as any)?.opSisaSaldo?.value?.toggle(event);
  }

  hideTooltip() {
    (this.$refs as any)?.opSisaSaldo?.value?.hide();
  }

  onReview() {
    if (this.flagAutoShowPopupFeedback) {
      FeedbackController.showPopupFeedback();
    }
  }

  onOpenReview() {
    FeedbackController.setOpenModalFeedbackFromSidebar(true);
    FeedbackController.setShowModalFeedback(true);
  }

  mounted() {
    this.onReview();
  }
}
